/* @flow */

export function getRelativePathForRedirectAfterLogin(location: { [x: string]: any }) {
    return "/login" + location.pathname;
}

export function getAbsolutePathForLogin() {
    const location = window.location;
    const origin = location.origin;
    const pathname = location.pathname.replace("shop", "").replace("logout", "").replace("//", "/");
    return `${origin}/shop/login${pathname}${location.search}`;
}
